import { Component } from 'react';
import React from 'react';
// import './Astor.css';
import {
  Box,
  Typography,
} from '@mui/material';
import Navbar from '../../Home/Components/Nav';
import Footer from '../../Home/Components/Footer';
// import Astorcarrousel from './Astorcarasole'
// import Features from './Features/Features';
// import Accessories from './Accessories/Accessories';
// import Carrosuel from './cardcarousel'
// import Slider from '@mui/material/Slider';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import ismart from '../../images/i-smart.svg';
// import sunroof from '../../images/sunroof.svg';
// import hd from '../../images/hdscreen.svg';
// import system from '../../images/autono.png';
// import astorlogo from '../../images/Astor/logo.png';
import Contactus from '../../contact/Container/Contactformcon'
// import Pricing from '../../MgAstor/Components/CityPricing'
// import Deets from '../../MgAstor/Components/deetssection';
import Majestorfaq from '../../MgMajestor/Components/Majestorfaq'
import VideoHero from './VideoHero';
import ColorCar from './CarColorSection';
import TallxHeroSection from './TallxHeroSection';
import PreReserveCTA from './PreReserveCTA';
import MLoungeSlider from './MLoungeSlider';
import MGCategoryShowcase from './Mgcategoryshowcase';
import OffRoadModes from './OffRoadModes';
import MHubSection from './MHubSection';
import ChooseYourMajestor from './Chooseyourmajestor ';

// import calculator from '../../images/calc.svg'


class Majestor extends Component {

  render() {
    return (
      <div id='container'>
        <Navbar />
        {/* Banner */}
        <VideoHero />


        <ColorCar />
        <OffRoadModes />

        {/* Accessories */}
        {/* <Accessories/> */}

        {/* Cards Carousel Section */}
        {/* <Carrosuel/> */}
        <MHubSection />
        <TallxHeroSection />

        {/* Image*/}
        <div id="majestorimg"></div>
        <PreReserveCTA />
        <MLoungeSlider />
        <MGCategoryShowcase />
        <ChooseYourMajestor />
        {/* contact us */}
        {/* <Contactus/> */}
        <Contactus someValue="Majestor" />




        {/* faqs */}
        <Majestorfaq />

        {/* Pricing Section */}
        {/* <Pricing/> */}
        {/* Footer Section */}
        <Footer />
        <style>{`
#majestorimg{
  height: 100vh; 
  width: 100%;
  background-image: url("https://mgmotor.scene7.com/is/image/mgmotor/pre-reserve-img-003?fmt=webp-alpha&resMode=bisharp&fit=constrain&qlt=90&hei=1080"); /* 💻 Laptop Image */
  background-repeat: no-repeat;
  background-size: cover; 
  background-position: center;
  display: flex;
  justify-content: flex-start; 
  align-items: center;
  padding-left: 50px; 
}


@media (max-width: 1024px) {
  #majestorimg {
    height: 90vh; 
    padding-left: 20px;
    padding-right: 20px; 
  }
}


@media (max-width: 780px) {
  #majestorimg {
    background-image: url("https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/pre-reserve-img-003-portrait.webp?alt=media&token=dbd82589-75c8-4473-8313-5ac32a2c5a9d"); /* 👈 Mobile Image */
    height: 90vh; 
    justify-content: center; 
    padding-left: 10px;
    padding-right: 10px;
  }
}


@media (max-width: 480px) {
  #majestorimg {
    height: 90vh; 
  }
}
`}</style>
      </div>
    );
  }
}

export default Majestor;